import PropTypes from 'prop-types';
import React from 'react';

const ToolTip = ({ children }) => (
    <div className="tool-tip">
        <div className="tool-tip-box">{children}</div>
        <div className="tool-tip-tail" />
    </div>
);

ToolTip.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

export default ToolTip;
